import React from "react";
import { FiHelpCircle, FiRefreshCw } from "react-icons/fi"; // Importing icons
import "./App.css";
import Tiles from "./Components/Tiles.js";
import Button from "react-bootstrap/Button";
import RulesModal from "./Components/Modal.js";

function App() {
  const [modalShow, setModalShow] = React.useState(false);
  const [playDaily, setPlayDaily] = React.useState(true);

  // Reference to Tiles component to call playAgain
  const tilesRef = React.useRef();

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-top-container">
          <h1>WAFFLE</h1>

          {/* Right-aligned buttons */}
          <div className="header-buttons d-flex gap-3">
            {!playDaily && ( // Show "New Game" button only in Unlimited mode
              <Button
                className="rounded-circle"
                variant="dark"
                onClick={() => tilesRef.current.playAgain()}
              >
                <FiRefreshCw size={22} /> {/* Refresh icon */}
              </Button>
            )}
            <Button
              className="rounded-circle"
              variant="dark"
              onClick={() => setModalShow(true)}
            >
              <FiHelpCircle size={22} /> {/* Help icon */}
            </Button>
          </div>
        </div>

        {/* Toggle Switch for Daily/Buffet */}
        <div className="switches-container">
          <input
            type="radio"
            id="switchDaily"
            name="switchMode"
            value="Daily"
            checked={playDaily}
            onChange={() => setPlayDaily(true)}
          />
          <input
            type="radio"
            id="switchBuffet"
            name="switchMode"
            value="Buffet"
            checked={!playDaily}
            onChange={() => setPlayDaily(false)}
          />
          <label htmlFor="switchDaily">Daily</label>
          <label htmlFor="switchBuffet">Unlimited</label>
          <div className="switch-wrapper">
            <div className="switch">
              <div>Daily</div>
              <div>Unlimited</div>
            </div>
          </div>
        </div>

        <Tiles ref={tilesRef} playDaily={playDaily} />
      </header>

      <RulesModal show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
}

export default App;
